import styled from "styled-components";
import { Users, Code2, Target, ShieldCheck, Sparkles } from "lucide-react";
const TrustSection = styled.section`
  padding: 120px 24px;
  background: linear-gradient(180deg, transparent, rgba(56, 189, 248, 0.05));
`;

const TrustContainer = styled.div`
  max-width: 1100px;
  margin: auto;
`;

const TrustHeader = styled.div`
  max-width: 760px;
  margin-bottom: 70px;
`;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.18);
  color: #7dd3fc;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

const TrustTitle = styled.h2`
  font-size: clamp(28px, 4vw, 38px);
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 16px;
  color: #f8fafc;
`;

const TrustSub = styled.p`
  font-size: 17px;
  line-height: 1.7;
  color: #9ca3af;
`;

const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 30px;
`;

const TrustCard = styled.div`
  padding: 28px;
  border-radius: 20px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.1);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba(245, 158, 11, 0.24);
    box-shadow: 0 22px 60px rgba(245, 158, 11, 0.12);
  }
`;

const TrustIcon = styled.div`
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f59e0b, #38bdf8);
  margin-bottom: 16px;
`;

const TrustCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 10px;
`;

const TrustText = styled.p`
  font-size: 15px;
  line-height: 1.6;
  color: #9ca3af;
`;
export function TrustSectionBlock() {
  return (
    <TrustSection>
      <TrustContainer>
        <TrustHeader>
          <Eyebrow>
            <Sparkles size={14} />
            Product Trust
          </Eyebrow>
          <TrustTitle>
            Built for real developer decisions, not internet hype
          </TrustTitle>
          <TrustSub>
            `skilll.dev` is built around actual career confusion: choosing the
            wrong path, learning without a system, and wasting months on
            scattered effort. This is clarity designed to become execution.
          </TrustSub>
        </TrustHeader>

        <TrustGrid>
          <TrustCard>
            <TrustIcon>
              <Code2 size={22} />
            </TrustIcon>
            <TrustCardTitle>Real engineering mindset</TrustCardTitle>
            <TrustText>
              The thinking here is practical: foundations first, depth next,
              then roadmap execution that compounds into proof of work.
            </TrustText>
          </TrustCard>

          <TrustCard>
            <TrustIcon>
              <Target size={22} />
            </TrustIcon>
            <TrustCardTitle>No generic advice</TrustCardTitle>
            <TrustText>
              Recommendations come from your answers, current level, and goals,
              not from trending stacks or whatever is loud on YouTube.
            </TrustText>
          </TrustCard>

          <TrustCard>
            <TrustIcon>
              <Users size={22} />
            </TrustIcon>
            <TrustCardTitle>Built after mentoring developers</TrustCardTitle>
            <TrustText>
              The patterns come from helping real students, job seekers, and
              developers who needed clarity before they needed more content.
            </TrustText>
          </TrustCard>

          <TrustCard>
            <TrustIcon>
              <ShieldCheck size={22} />
            </TrustIcon>
            <TrustCardTitle>No spam. No pressure.</TrustCardTitle>
            <TrustText>
              Take the test without login, get clarity first, and only go
              deeper if the roadmap genuinely feels useful.
            </TrustText>
          </TrustCard>
        </TrustGrid>
      </TrustContainer>
    </TrustSection>
  );
}
